import { Action, ActionReducer } from '@ngrx/store'
import { APPOINTMENT_DATE } from '../../modules/appointment/appointment.actions'
import { AUTH, AUTH_OEM, AUTH_RENTAL, AUTH_VAS, PASSKEY_AUTH, PASSKEY_REGISTER } from '../../modules/auth/auth.actions'
import { RapAuthFailure } from '../../modules/auth/auth.types'
import { ACTIVE_CALL_STATUS, CALL_STATUS } from '../../modules/dashboard/calls-statuses/call-status.actions'
import { ADD_PARTIAL_CALL, CALL_CANCEL } from '../../modules/dashboard/calls.actions'
import { SET_EXCLUDED_AREAS, SET_HIGHWAY_EXITS, SET_LOCATION_CLUB, } from '../../modules/location/location.actions'
import { MEMBERS_SEARCH, VEHICLE_ADD, VEHICLE_UPDATE } from '../../modules/member/member.actions'
import { BATTERY_QUOTES } from '../../modules/quotes/quotes.action'
import { SET_SERVICING_CLUB_CONFIGS } from '../../modules/servicing-club/servicing-club.actions'
import { TOW_SERVICE_AVAILABILITY } from '../../modules/tow-service-availability/tow-service-availability.actions'
import { ErrorDialogTypes } from '../../modules/ui/ui.types'
import { ENRICH_VEHICLE_DETAILS, VEHICLE_DETAILS, VEHICLE_YEARS } from '../../modules/vehicle/vehicle.actions'
import { PayloadedAction } from '../../shared/types'
import { AAAStore } from '../root-reducer'
import { getActionErrorMessage } from './errors.messages'
import { ISSUE_OPTIONS } from '../../modules/issue/issue.actions'

const ignoreList = [
  ADD_PARTIAL_CALL.FAILURE,
  SET_HIGHWAY_EXITS.FAILURE,
  SET_LOCATION_CLUB.FAILURE,
  SET_SERVICING_CLUB_CONFIGS.FAILURE,
  BATTERY_QUOTES.FAILURE,
  CALL_STATUS.FAILURE,
  ACTIVE_CALL_STATUS.FAILURE,
  MEMBERS_SEARCH.FAILURE,
  AUTH.FAILURE,
  VEHICLE_YEARS.FAILURE,
  VEHICLE_DETAILS.FAILURE,
  ENRICH_VEHICLE_DETAILS.FAILURE,
  APPOINTMENT_DATE.FAILURE,
  AUTH_OEM.FAILURE,
  SET_EXCLUDED_AREAS.FAILURE,
  PASSKEY_AUTH.FAILURE,
  PASSKEY_REGISTER.FAILURE,
  ISSUE_OPTIONS.FAILURE,
  // Fail-open: a tow-service-availability failure falls back to { enabled: true }
  // and the tow proceeds (see AdvisoriesEffects.handleTowServiceAvailability$), so
  // the user is never blocked by a club backend outage. The global error toast is
  // suppressed because there is nothing for the user to act on.
  TOW_SERVICE_AVAILABILITY.FAILURE,
  // We might want to review the vehicle add/update failures since they are made asynchronously and the user might get confused why it is being displayed on the issue page
  // VEHICLE_ADD.FAILURE,
  // VEHICLE_UPDATE.FAILURE,
]

export function errorMiddleware(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return function newReducer(state: AAAStore, action: Action & { payload: RapAuthFailure }) {
    const isDialogActive = state && Object.keys(state.ui.dialog).length > 0
    const isAuthNoRouting = Boolean(state?.auth.noRouting)
    const isFailure = action.type.includes('FAILURE')
    const shouldIgnore = ignoreList.includes(action.type) || (action as PayloadedAction).payload?.ignoreFailure

    if (
      !isDialogActive &&
      isFailure &&
      !shouldIgnore &&
      !isAuthNoRouting
    ) {
      const isRap = !!state?.auth?.modeConfig
      const failureContent = getActionErrorMessage(action, isRap)

      switch (action.type) {
        case AUTH_VAS.FAILURE:
          state = {
            ...state,
            ui: {
              ...state.ui,
              dialog: {
                ...state.ui.dialog,
                [ErrorDialogTypes.AUTH_VAS]: { type: ErrorDialogTypes.AUTH_VAS },
              },
            },
          }
          break
        case AUTH_RENTAL.FAILURE:
          state = {
            ...state,
            ui: {
              ...state.ui,
              dialog: {
                ...state.ui.dialog,
                [ErrorDialogTypes.AUTH_RENTAL]: { type: ErrorDialogTypes.AUTH_RENTAL },
              },
            },
          }
          break
        case AUTH.FAILURE:
          state = {
            ...state,
            ui: {
              ...state.ui,
              dialog: {
                ...state.ui.dialog,
                [ErrorDialogTypes.AUTH]: { type: ErrorDialogTypes.AUTH },
              },
            },
          }
          break
        case CALL_CANCEL.FAILURE:
          state = {
            ...state,
            ui: {
              ...state.ui,
              dialog: {
                ...state.ui.dialog,
                [ErrorDialogTypes.CALL_CANCEL]: { type: ErrorDialogTypes.CALL_CANCEL },
              },
            },
          }
          break
        default:
          state = {
            ...state,
            ui: {
              ...state.ui,
              dialog: {
                ...state.ui.dialog,
                [ErrorDialogTypes.GENERIC]: {
                  type: ErrorDialogTypes.GENERIC,
                  content: failureContent,
                },
              },
            },
          }
      }
    }

    return reducer(state, action)
  }
}
